module.exports = __webpack_public_path__ + "img/sougou.e8faee05.png";